<template>
<div class="info-item-wrapper">
    <div class="row header">
        <div class="col-12">
            <info-ceckbox
                :label="label"
                :value="isEnabled"
                @input="$emit('set-enabled', $event)"
            />
        </div>
    </div>
    <div class="row body" v-bind:class="{'disabled-overlay' :!isEnabled}">
        <div class="col-12">
            <slot></slot>
        </div>
    </div>
</div>
</template>

<script>

import resourceMixin from '../../../../Util/Mixins/resources';

//Components
import InfoCeckbox from './Components/InfoCheckBox.vue';

export default {
    name: 'info-item',
    mixins: [resourceMixin],
    components: {
        InfoCeckbox
    },
    props: {
        isEnabled: {
            type: Boolean,
            required: true
        },
        label: {
            type: String,
            required: true
        }
    }
}

</script>

<style scoped src="../../Style/info-item.scss" lang="scss">
</style>
